import { render, staticRenderFns } from "./RolesTab.vue?vue&type=template&id=0ba0a85f&scoped=true"
import script from "./RolesTab.vue?vue&type=script&lang=js"
export * from "./RolesTab.vue?vue&type=script&lang=js"
import style0 from "./RolesTab.vue?vue&type=style&index=0&id=0ba0a85f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0a85f",
  null
  
)

export default component.exports